import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useContent } from '../contexts/ContentContext';

const About = () => {
  const { getContent } = useContent();
  const pageHeader = getContent('about.pageHeader') || {};
  const coreValues = getContent('about.coreValues') || {};
  const missionVision = getContent('about.missionVision') || {};
  const companyStory = getContent('about.companyStory') || {};
  const threeBlocks = getContent('about.threeBlocks') || {};
  const chronologie = getContent('about.chronologie') || {};
  const aboutCta = getContent('about.cta') || {};
  

  useEffect(() => {
    // Interactive Timeline functionality
    const timelineItems = document.querySelectorAll('.timeline-item.interactive');
    
    timelineItems.forEach(item => {
      const contentHeader = item.querySelector('.content-header');
      
      const handleClick = () => {
        // Close all other timeline items
        timelineItems.forEach(otherItem => {
          if (otherItem !== item) {
            otherItem.classList.remove('expanded');
          }
        });
        
        // Toggle current item
        item.classList.toggle('expanded');
      };
      
      contentHeader.addEventListener('click', handleClick);
      
      // Cleanup event listener
      return () => {
        contentHeader.removeEventListener('click', handleClick);
      };
    });
    
    // Cleanup function for useEffect
    return () => {
      timelineItems.forEach(item => {
        const contentHeader = item.querySelector('.content-header');
        if (contentHeader) {
          contentHeader.removeEventListener('click', () => {});
        }
      });
    };
  }, []);

  return (
    <div className="about-page">
      {/* Page Header */}
      <section className="page-header">
        <div className="container">
          <div className="page-header-content">
            <h1>{pageHeader.title || 'À propos de Nous'}</h1>
            <p>{pageHeader.subtitle || 'Découvrez notre mission, nos valeurs et l\'équipe d\'experts qui font de DentoXcellence le leader de la formation dentaire en Algérie'}</p>
          </div>
        </div>
      </section>

      {/* 3 Blocs: Notre Histoire, Notre Vision, Notre Historique */}
      <section className="three-blocks-section" id="three-blocks">
        <div className="container">
          
          {/* Notre Histoire */}
          <div className="about-block histoire-block" id="company-story">
            <div className="block-image-text">
              <div className="block-image">
                {threeBlocks.histoire?.image ? (
                  <img src={threeBlocks.histoire.image} alt={threeBlocks.histoire?.title || 'Notre Histoire'} />
                ) : (
                  <div className="block-image-placeholder">
                  <i className={threeBlocks.histoire?.icon || "fas fa-history"}></i>
                  </div>
                )}
              </div>
              <div className="block-content">
                <div className="block-header">
                <h2>{threeBlocks.histoire?.title || 'Notre Histoire'}</h2>
                <p className="block-subtitle">
                  {threeBlocks.histoire?.subtitle || "L'aventure DentoXcellence : de la vision à la réalité"}
                </p>
              </div>
              <div className="block-body">
                  <p>
                  {threeBlocks.histoire?.intro || companyStory.intro || 'DentoXcellence est né de la vision de révolutionner la formation dentaire en Algérie en apportant les standards internationaux de formation et les technologies les plus avancées.'}
                </p>
                </div>
              </div>
            </div>
            </div>
            
          {/* Notre Vision */}
          <div className="about-block vision-block" id="mission-vision">
            <div className="block-image-text reverse">
              <div className="block-image">
                {threeBlocks.vision?.image ? (
                  <img src={threeBlocks.vision.image} alt={threeBlocks.vision?.title || 'Notre Vision'} />
                ) : (
                  <div className="block-image-placeholder">
                    <i className={threeBlocks.vision?.icon || "fas fa-eye"}></i>
                  </div>
                )}
              </div>
            <div className="block-content">
              <div className="block-header">
                <h2>{threeBlocks.vision?.title || 'Notre Vision'}</h2>
                <p className="block-subtitle">
                  {threeBlocks.vision?.subtitle || "Vers l'excellence dentaire de demain"}
                </p>
              </div>
              
              <div className="block-body">
                  <p>
                    {threeBlocks.vision?.intro || threeBlocks.vision?.ambition?.description || missionVision.vision?.description || 'Être le référent incontournable de la formation dentaire avancée en Algérie et dans la région MENA, en offrant des programmes de formation de niveau international qui transforment la pratique dentaire.'}
                  </p>
                </div>
              </div>
            </div>
          </div>

                </div>
      </section>

      {/* Nos Valeurs Fondamentales - MOVED HERE */}
      <section className="core-values" id="core-values">
        <div className="container">
          <div className="section-header">
            <h2 className="section-title">{coreValues.title || 'Nos Valeurs Fondamentales'}</h2>
            <p className="section-subtitle">{coreValues.subtitle || 'Les principes qui guident notre excellence en formation dentaire'}</p>
            </div>
          <div className="values-grid-full">
            {(coreValues.values || []).map((value, index) => (
              <div key={index} className="value-item">
                <div className="value-icon">
                  {value.iconImage ? (
                    <img src={value.iconImage} alt={value.title} className="value-icon-image" />
                  ) : (
                    <i className={value.icon}></i>
                  )}
                </div>
                <h4>{value.title}</h4>
                <p>{value.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Notre Historique - Chronologie */}
      <section className="historique-section" id="historique">
        <div className="container">
          <div className="about-block historique-block">
            <div className="historique-centered-layout">
              <div className="block-header centered">
                <h2>{chronologie.title || 'Notre Historique'}</h2>
                <p className="block-subtitle">
              {chronologie.subtitle || 'Parcourez l\'évolution de DentoXcellence à travers les années'}
            </p>
          </div>
          
              <div className="historique-image-center">
                {chronologie?.image ? (
                  <img src={chronologie.image} alt={chronologie?.title || 'Notre Historique'} />
                ) : (
                  <div className="historique-image-placeholder">
                    <i className="fas fa-clock"></i>
                </div>
                )}
              </div>

              <p className="historique-intro centered">
                {chronologie.intro || 'De nos débuts modestes à notre position actuelle de leader en formation dentaire, découvrez les moments clés qui ont façonné DentoXcellence.'}
              </p>
              
              <div className="historique-two-columns">
                {(chronologie.timeline || []).map((item, index) => (
                  <div key={index} className="summary-item">
                    <span className="summary-year">{item.year}</span>
                    <h4>{item.title}</h4>
                    <p>{item.summary}</p>
              </div>
            ))}
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Call to Action */}
      <section className="cta">
        <div className="container">
          <div className="cta-content">
            <h2>{aboutCta.title || 'Prêt à Transformer Votre Pratique ?'}</h2>
            <p>{aboutCta.subtitle || 'Rejoignez plus de 500 dentistes qui ont fait confiance à DentoXcellence pour leur développement professionnel'}</p>
            <div className="cta-buttons">
              {(aboutCta.buttons || []).map((button, index) => (
                button.link?.startsWith('http') ? (
                  <a key={index}
                     href={button.link} 
                     className={`btn btn-${button.type}`}
                     target="_blank" 
                     rel="noopener noreferrer">
                    <i className={button.icon}></i>
                    {button.text}
                  </a>
                ) : (
                  <Link key={index} to={button.link} className={`btn btn-${button.type}`}>
                    <i className={button.icon}></i>
                    {button.text}
              </Link>
                )
              ))}
            </div>
          </div>
        </div>
      </section>

    </div>
  );
};

export default About;

